// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import { useTranslation } from 'react-i18next';
import RainbowText from '../../common/rainbowText';
import ABOUT_DELIVERY from '../../../../assets/imgs/lotteryDetail/about_delivery.png';

import { dotted, dottedDeliveryPC, dottedDeliverySP } from '../../../../assets/imgs';

export default function DeliveryInfo(props) {
  const shipQuantity = props.data.lottery_event.ship_quantity;
  const { t } = useTranslation();

  return (
    <div>
      <div
        className="border-dots"
        style={{
          backgroundImage: `url(${dotted})`,
          backgroundSize: '1200px',
          backgroundRepeatY: 'no-repeat',
          height: '10px',
          paddingBottom: '15px',
        }}
      ></div>
      <div className="delivery-info-lottery-detail border-top-dots">
        <div className="delivery-info-content">
          {/* <h1>{t('aboutDelivery')}</h1>
          <div className="line" />
          <h2>
            <RainbowText text={t('aboutDeliveryJp')} />
          </h2> */}
          <div className="about-delivery">
            <img src={ABOUT_DELIVERY} alt="img" />
          </div>

          <div className="delivery mt-40">
            <div className="delivery-box">
              <span className="my-tag my-bg-dark-red">{t('textTimeDelivery')}</span>
            </div>
            <div className="delivery-dotted">
              <img src={dottedDeliveryPC} className="dotted-PC" />
              <img src={dottedDeliverySP} className="dotted-SP" />
            </div>
            <p>{t('descriptionTimeDelivery')}</p>
          </div>
          <div className="delivery">
            <div className="delivery-box">
              <span className="my-tag my-bg-dark-red">{t('textShippingMethod')}</span>
            </div>
            <div className="delivery-dotted">
              <img src={dottedDeliveryPC} className="dotted-PC" />
              <img src={dottedDeliverySP} className="dotted-SP" />
            </div>
            <p>{t('descriptionShippingMethod')}</p>
          </div>
          <div className="delivery">
            <div className="delivery-box">
              <span className="my-tag my-bg-dark-red">送料について</span>
            </div>
            <div className="delivery-dotted">
              <img src={dottedDeliveryPC} className="dotted-PC" />
              <img src={dottedDeliverySP} className="dotted-SP" />
            </div>
            <p className="note-time">
              複数回購入でも累計で「{shipQuantity}枚」まで1回分の配送手数料のご負担となります。
              <br />
              購入数が1回分の手数料でお届けできる個数を超えた場合、以降、上限の個数ごとに手数料が発生します。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
